import { useEffect, useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import { A } from '@/constants/journey';
import { useLive } from '@/lib/live';

// The threshold. Light collapses; the next world preloads behind darkness.
export const S04Tunnel = () => {
  const { reducedMotion } = useLive();
  const sectionRef = useRef(null);
  const plateRef = useRef(null);
  const darkRef = useRef(null);
  const copyRef = useRef(null);
  const rainRef = useRef(null);

  useEffect(() => {
    // Preload only the first two cinematic frames while the visitor is in the tunnel.
    ['/assets/cinematic-v3/s05-world-master.webp', '/assets/cinematic-v3/s05-bonk-arrival.webp'].forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useLayoutEffect(() => {
    if (reducedMotion) return undefined;
    const ctx = gsap.context(() => {
      const tl = gsap.timeline({
        scrollTrigger: { trigger: sectionRef.current, start: 'top top', end: 'bottom bottom', scrub: 1.05, fastScrollEnd: true },
      });
      tl.fromTo(plateRef.current, { scale: 1 }, { scale: 1.18, ease: 'none' }, 0)
        .fromTo(rainRef.current, { opacity: 0.35 }, { opacity: 0 }, 0.25)
        .fromTo(copyRef.current, { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.18 }, 0.28)
        .to(copyRef.current, { opacity: 0, duration: 0.18 }, 0.72)
        .fromTo(darkRef.current, { opacity: 0 }, { opacity: 0.97, duration: 0.4 }, 0.6);
    }, sectionRef);
    return () => ctx.revert();
  }, [reducedMotion]);

  return (
    <section ref={sectionRef} className="relative h-[230vh]" data-testid="chapter-s04" data-audio-scene="tunnel" aria-label="No signal in the tunnel">
      <div className="sticky top-0 h-screen overflow-hidden grain">
        <picture>
          <source media="(max-width: 640px)" srcSet="/assets/cinematic-v3/s04-tunnel-mobile-v2.webp" />
          <img
            ref={plateRef}
            src={A.plates.s04}
            alt="Thomas enters a dark brick tunnel with green signal reflections"
            className="absolute inset-0 h-full w-full object-cover will-change-transform"
            loading="lazy"
          />
        </picture>
        <img ref={rainRef} src={A.fx.rain} alt="" className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-35" style={{ mixBlendMode: 'screen' }} />
        <div className="scrim-tunnel absolute inset-0" />
        <div ref={darkRef} className="absolute inset-0 bg-[#050608]" style={{ opacity: reducedMotion ? 0 : 0 }} />

        <div ref={copyRef} className="absolute inset-x-0 top-[42%] px-4 text-center" style={{ opacity: reducedMotion ? 1 : 0 }}>
          <h2 className="font-display text-4xl tracking-wide text-[#f3e7cf] sm:text-6xl">NO WIFI PAST THIS TUNNEL.</h2>
          <p className="mt-2 font-sans text-[13px] font-medium leading-relaxed text-[#f3e7cf] sm:text-[15px]">GOOD. THE TRAIN STILL WORKS.</p>
        </div>
      </div>
    </section>
  );
};
